import { memo, useId, type SVGProps } from "react";

import { withUniqueSvgIds } from "./withUniqueSvgIds";

const SvgSpinner = (props: SVGProps<SVGSVGElement>) => {
  const idPrefix = useId().replace(/:/g, "");

  return withUniqueSvgIds(
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="7 6.5 46 46"
      aria-hidden="true"
      {...props}
    >
      <path
        fill="url(#spinner_svg__a)"
        d="M48 29.5a18 18 0 1 0-36 0 18 18 0 0 0 36 0m4 0a22 22 0 1 1-44 0 22 22 0 0 1 44 0"
      />
      <defs>
        <linearGradient
          id="spinner_svg__a"
          x1={15}
          x2={30}
          y1={44}
          y2={30}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4ea974" />
          <stop offset={0.38} stopColor="#61d18d" />
          <stop offset={0.65} stopColor="#eaeaeb" />
        </linearGradient>
      </defs>
    </svg>,
    idPrefix,
  );
};

const Memo = memo(SvgSpinner);
export default Memo;
